import React from 'react';

const SheetsContext = React.createContext({
  //
});

export default SheetsContext;
